<template>
  <v-flex xs12 sm6 offset-sm3 distancebtom >
  <v-card flat class="card-outline-inverse scroll-y" v-if="!loading" id = "scroll-target">
      <v-card-text dark class="card-header">
        <h5 class="m-b-0 text-white" style="text-align: left;">
            Flight Request
        </h5>
      </v-card-text  id="scrolled-content">
       <v-tabs v-model="active_tabs">
        <!--  <v-tabs-slider color="blue"></v-tabs-slider>  :style="{ maxHeight: winHeight, backgroundColor: 'white' }" -->
        <v-tab color="white" class="grey--text fixWidth" active-class="nav-link active">
          Costing ({{this.numberOfCostingCount}})
        </v-tab>
         <v-tab-item v-show="showTab1" class="box-1 px-12">
            <v-card flat class="txleft">
                
               <ul  v-if=" this.numberOfCostingCount > 0 "  class="search-listing">
                <li v-for="(item1, index1) in flightCosting" class="flrequest">
                    <p :id="item1.id"> 
                         {{item1.request_user_name}} 
                      <span class="sl-date font-blue">{{item1.created_on}} </span>
                    </p>
                     
                   <custom-dialog v-model="flight_costing" 
                      :commentId="{flightid:item1.id}"

                      requestType="flight_costing"
                      modalTitle="Approve" ref="form1" 
                      v-if="isSalePrivilege==true"
                      />
                    <reject-dialog v-model="delete_costing" 
                      :commentId="{flightid:item1.id}"
                      requestType="flight_costing"
                      modalTitle="Reject" ref="form1"
                      v-if="isSalePrivilege==true"
                     />
                    
                   
                    <span class="cusfont16px" v-on:click.capture='goToDetail(item1.campaign_id,"flight_costing" )'>({{item1.campaign_id}})  
                       <a > {{item1.campaign_name}}</a>
                    </span> 
                    <span class="font-blue">
                      ({{item1.campaign_date}})</span> 
                      <br>

                    <span class="cusfont15px">
                       <i class="fa fa-angle-right iconright"></i>({{item1.flight_id}}) <a v-on:click.capture='goToDetail_flight(item1.campaign_id,"flight_costing", item1.flight_id)'>
                         {{item1.flight_name}}
                       </a>
                    </span>
                    <span class="font-blue">({{item1.flight_date}})</span><br>
                    <span class="title">Reason </span><br>
                    <span class="titlebold">{{item1.reason}} </span>

                    <v-expansion-panel expand :id="index1"  @click.native="doSomething($event,index1)" >
                        <v-expansion-panel-content expand-icon="mdi-minus">
                         <div slot="header" >
                            <a class="btn waves-effect waves-light btn-secondary small v-expansion-panel__header__icon mtop" ><i class="mdi mdi-plus"></i></a>
                           <!--  <a class="btn waves-effect waves-light btn-secondary small v-expansion-panel__header__icon mtop" >
                              <i class="fa fa-fw " v-bind:class="cssClosed" ></i>
                           </a> -->
                         </div>

                         <!--  <v-card> -->
                           
                            <table class="itemdata table table-hover table-top" v-for="(itm,index) in item1.item_update " >
                              <tbody>
                                <tr class="bordertable">
                                   <td> <span class="text-muted">Item </span></td>
                                  <td class="text-right text-muted">{{index}}</td>
                                </tr>
                                <tr>
                                   <td>Old Value</td>
                                   <td class="text-right">{{itm.old}}</td>
                                </tr>
                                <tr>
                                   <td>New Value</td>
                                   <td class="text-right"> <div v-html="handleNewLine(itm.new)"></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                         <!--  </v-card> -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
              
                 <!-- <div style="clear: both"></div> -->
                </li>
              </ul>
              <v-card-text class="notfound" v-else>No Data Found</v-card-text>
            </v-card>
          </v-tab-item>
        <v-tab color="white"  class="grey--text fixWidth" active-class="nav-link active">
             Pending ({{this.numberOfPendingCount}})
        </v-tab>
        <v-tab-item  v-show="showTab2" class="box-1 px-12">
           <v-card flat class="txleft">
             <ul  v-if=" this.numberOfPendingCount > 0 "  class="search-listing">
                <li v-for="(item1, index1) in flightPending">
                   <p> 
                         {{item1.request_user_name}}
                      <span class="sl-date font-blue sl-date-l">{{item1.created_on}}</span>
                    </p> 
                   
            
                    <custom-dialog v-model="flight_costing" 
                      :commentId="{flightid:item1.id}"
                      requestType="pending_flight"
                      modalTitle="Approve" ref="form1" v-if="isSalePrivilege==true"/>

                    <reject-dialog v-model="delete_costing" 
                      :commentId="{flightid:item1.id}"
                      requestType="pending_flight"
                      modalTitle="Reject" ref="form1" v-if="isSalePrivilege==true"/>

            
                    <span class="cusfont16px"  v-on:click.capture='goToDetail(item1.campaign_id,"pending_flight" )'>({{item1.campaign_id}}) 
                       <a> {{item1.campaign_name}}</a>
                      </span> 
                    <span class="font-blue">
                      ({{item1.campaign_date}})</span> 
                      <br/>
                     
                        <span>
                         <a v-on:click.capture='goToDetail_flight(item1.campaign_id,"pending_flight", item1.id)'>
                           {{item1.pending_flight_name}}
                         </a>
                        </span>
                     
                </li>

              </ul>
              <v-card-text class="notfound" v-else>No Data Found</v-card-text>
            </v-card>
        </v-tab-item>
          <v-tab color="white"  class="grey--text fixWidth" active-class="nav-link active">
               Delete ({{this.numberOfDeleteCount}})
          </v-tab>

            <v-tab-item  v-show="showTab3" class="box-1 px-12">
             <v-card flat class="txleft">
              <ul  v-if=" this.numberOfDeleteCount > 0 "  class="search-listing">
                <li v-for="(item1, index1) in flightDelete" >
                   <p> 
                         {{item1.request_user_name}}
                      <span class="sl-date font-blue">{{item1.created_on}}</span>
                    </p> 
                  
                    <custom-dialog v-model="flight_costing" 
                      :commentId="{flightid:item1.id}"
                      requestType="delete_flight"
                      modalTitle="Approve" ref="form1"
                      v-if="isSalePrivilege==true"
                      />
                    <reject-dialog v-model="delete_costing" 
                     :commentId="{flightid:item1.id}"
                      requestType="delete_flight"
                      modalTitle="Reject" ref="form1"
                      v-if="isSalePrivilege==true"
                      />

                    <span class="cusfont16px" v-on:click.capture='goToDetail(item1.campaign_id,"delete_flight" )'>({{item1.campaign_id}})
                    <a> {{item1.campaign_name}}</a>
                     </span> 
                    <br>
                    <span class="font-blue">
                      ({{item1.campaign_date}})</span> 
                     
                    <span class="cusfont15px">
                        <i class="fa fa-angle-right iconright"></i>  ({{item1.flight_id}})<a v-on:click.capture='goToDetail_flight(item1.campaign_id,"delete_flight", item1.flight_id)'>
                         {{item1.flight_name}}
                       </a>
                    </span>
                    <span class="font-blue sl-date-l">({{item1.flight_date}})</span><br>
                    <span class="title">Delete Reason </span><br>
                     <span class="titlebold">{{item1.reason}} </span><br> 
                </li>
              </ul>
              <v-card-text class="notfound" v-else>No Data Found</v-card-text>
            </v-card>
          </v-tab-item>
       </v-tabs>
   </v-card>
   </v-flex>
</template>



<style scoped>
p{
   margin-top: 8px;
}
.search-listing li.flrequest{
    
    width: 100%;
    padding-top: 5px !important;
    padding: 0px 0 !important;
}
.search-listing li:after {
  content: "";
  position: absolute;
  z-index: 1;
  border-bottom: 1px solid rgba(120, 130, 140, 0.13);
  display: block;
  top: 0%;
  right: 0%;
  height: 100%;
}
.search-listing li {
  
}
.v-panel__header{
 /* border: 1px red solid;*/
  z-index: 11111;
 
}
.mtop{
  /*margin-top: -32px;*/
 /* margin-left: -22px;*/
}
.title{
  font-weight: normal !important;
  font-family: Helvetica, Arial, sans-serif !important;
  font-size: 16px !important;
}
.titlebold{
    font-size: 16px;
    font-weight: bold;
}
.btn-secondary {
  border: 1px solid #727b84 !important;
}
.fa-angle-right{
  padding-right: 6px !important;
  font-size: x-large !important;
}
.btn-secondary:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
}
i.fa{
  padding-right: 0px;
}
.table-hover{
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}
.text-right {
    text-align: right!important;
  }
.table-top{
      margin-top: 50px;
}

</style>

<script>
  import { loginService } from '@/components/_service/Users.js';
  import CustomDialog from '@/components/CustomDialog';
  import RejectDialog from '@/components/RejectDialog';
  import SimpleForm from '@/components/SimpleForm';
  const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
  export default {
    name: 'FlightRequest',
  
    components: {
      CustomDialog,
      RejectDialog,
      
    },
    data () {
      return {
        active_tabs: 0,
        showTab1:false,
        showTab2:false,
        showTab3:false,

        openSection: true,
        cssClosed : "fa-plus",
        str:"list",
        item_name:"",
        flight_costing: true,
        delete_costing: true,
        delete_flight:false, 

        pending_flight:false,      
        commentId:"",
        modalTitle:"",
        request_type:"",
        isModalVisible:false,
        loading:true,
        userId:loginService.getSaleId(),
        flightcount:0,
        winHeight: window.innerHeight *1 + "px",
        container: null,
        elem: null,
        scrollTop: 400
      //  isSalePrivilege:false
       // flightPending:[],
        //numberOfPendingCount:0
      
      }
    },
  
    
    computed:{

      numberOfCostingCount(){
        
         return  this.$store.state.numberOfCostingCount
      },
      numberOfPendingCount(){
        
         return this.$store.state.numberOfPendingCount
      },
      numberOfDeleteCount(){
         return this.$store.state.numberOfDeleteCount
      },
      flightPending(){
        return this.$store.state.flightPendings
      },
     
      flightCosting(){
        return this.$store.state.flightCostings
      },
     
      flightDelete(){
        return this.$store.state.flightDeletes
      },

      isSalePrivilege(){
      // console.log(this.$store.state.isSalePrivilege)
        return this.$store.state.isSalePrivilege.approve_flight_request
      }
    },
   
    methods: {
       getFlightCosting () {
          
            this.$store.dispatch('getFlightRequest','flight_costing')
             .then(() => 

                this.loading =false
             
              )
             .catch(err => {
                console.log(err )
               
             })
             .finally(() => this.loading = false)
        
         
        },
        getFlightPending () {
        
           this.$store.dispatch('getFlightRequest','pending_flight')
             .then(() => 

                this.loading =false
             
              )
             .catch(err => {
                console.log(err )
               
             })
             .finally(() => this.loading = false)
          
        },
        getFlightDelete () {
           this.$store.dispatch('getFlightRequest','delete_flight')
             .then(() => 

                this.loading =true
             
              )
             .catch(err => {
                console.log(err )
               
             })
             .finally(() => this.loading = false)
      
        },
       
  
        goToDetail(camid,act){

          this.$router.push({ name: 'detail', params: { id: camid,flightid:0  }, query:{act:act} })
        
        },
        goToDetail_flight(camid,act,flightid){
          this.$router.push({ name: 'detail', params: { id: camid,flightid:flightid  }, query:{act:act} })
        
        },      
        onInput (isOpen, n) {

          if (n === this.currSection) {
            // This only seems to come in false when closing for loss of focus (on a close, not on the open/close toggle).
            // this.openSection = !this.openSection;  // can't toggle since the open=true never comes in
            this.openSection = isOpen;
          } else {
            this.openSection = true;
           
          }
          //  console.log(this.currSection)
          this.currSection = n;
        
        },    
        doSomething (e,n) {         
         if (e.currentTarget.getAttribute('id') == n){

              if (e.currentTarget.firstChild.childNodes[0].parentElement.className === "v-expansion-panel__container v-expansion-panel__container--active"){
              //  console.log(e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0])
                  const arr = e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0].childNodes[0].classList
                  //arr.value ="fa-minus"
                //  if ( arr.value == "")
                 this.openSection = false;
               
                 arr.value ="mdi mdi-plus"
             //     console.log( arr.value )  
               
                 
               }else{
                 const arr = e.currentTarget.firstChild.childNodes[0].childNodes[0].childNodes[0].childNodes[0].classList
                  arr.value ="mdi mdi-minus"
                this.openSection = true;
               
             }
           
         }
       
      },
     updateparent(variable) {
        this.commentId = variable
      },
      openTestDialog (e,s,n) {
         
          if (s === 'reject_remark'){
            this.delete_costing =true;
            this.requestType =s;
          }else if(s ==='approve_remark') {
         
            this.flight_costing = true
            this.requestType =s;
          } 
        
          this.commentId = n

      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      
       handleNewLine(str) {
         //var daaa ="4 Dec, 2018 - 31 Dec, 2018 &lt;br /&gt; 1 Feb, 2020 - 14 Feb, 2020";
        // console.log( str.replace(/(?:\r\n|\r|\n)/g, '<br />'))
           return str.replace(/(?:\r\n|\r|\n)/g, '&lt;br /&gt;');
       },

    },
    beforeUpdate() {
        
        this.flightcount= this.$store.getters.loadedTotalFlightCount;
      // console.log( this.flightcount)


        this.$emit('flight-send', this.flightcount);

 
 //            console.log(this.flightcount)
        if ( (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount > 0 && this.$store.state.numberOfDeleteCount > 0) ||
             (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount == 0)  ||
            (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount == 0) || 
            (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount== 0) ||
             (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount > 0)) {
             this.showTab1 = true;  
             this.active_tabs=0
        }

        if ( (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount > 0) || (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount == 0) ){
            this.showTab2 = true; 
            this.active_tabs=1
        }

        //console.log(this.showTab2 )
        if (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount > 0){

            this.showTab3 = true; 
            this.active_tabs=2
        }

      

    },
    created(){  
      this.getFlightCosting()
      this.getFlightPending()
      this.getFlightDelete()
      
    
       
    },
    mounted(){

        this.elem = document.getElementById ( "scrolled-content" )
        this.container = document.getElementById ( "scroll-target" )
        // if (this.elem){
        //   this.container.scrollTop = Math.floor ( this.elem.offsetHeight )   
        // }
       

        if (this.$route.query.act==="flight_costing"){
            this.showTab1 = true;  
            this.active_tabs=0
        } 
        if (this.$route.query.act==="pending_flight"){
            this.showTab2 = true;  
            this.active_tabs=1
        }
        if (this.$route.query.act==="delete_flight"){
            this.showTab3 = true;  
            this.active_tabs=2
        } 
        if (!this.$route.query.act || (this.$route.query.act !="aio" || this.$route.query.act !="approval" )) {

            if ( (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount > 0 && this.$store.state.numberOfDeleteCount > 0) ||
             (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount == 0)  ||
            (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount == 0) || 
            (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount== 0) ||
             (this.$store.state.numberOfCostingCount >  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount > 0)) {
             this.showTab1 = true;  
             this.active_tabs=0
            }

            if ( (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount > 0) || (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  > 0 && this.$store.state.numberOfDeleteCount == 0) ){
                this.showTab2 = true; 
                this.active_tabs=1
            }

            //console.log(this.showTab2 )
            if (this.$store.state.numberOfCostingCount ==  0 && this.$store.state.numberOfPendingCount  == 0 && this.$store.state.numberOfDeleteCount > 0){

                this.showTab3 = true; 
                this.active_tabs=2
            }
        }
       
        //  console.log(this.$store.getters.loadedTotalCamCount)
      
       
       
      

    },
     
   updated(){
    // console.log("sau" +  this.$store.getters.loadedTotalCamCount)
      
       // console.log(this.$store.getters.loadedTotalCamCount)
      

    },
  
  watch: {
    dialog (val) {
      if (!val) return
     //   console.log(this.$refs.focus)
        // this.$nextTick(this.$refs.txt.focus)
       requestAnimationFrame(() => {
         return this.$refs.focus
       })
    }
  },
 
   
  }
</script>